import { render, staticRenderFns } from "./HeroTree.vue?vue&type=template&id=cbcf822a&scoped=true"
import script from "./HeroTree.vue?vue&type=script&lang=js"
export * from "./HeroTree.vue?vue&type=script&lang=js"
import style0 from "./HeroTree.vue?vue&type=style&index=0&id=cbcf822a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cbcf822a",
  null
  
)

export default component.exports